module.exports = __webpack_public_path__ + "media/images/grey-plus-d92aab7a.png";